import {inviteSvg as Icon__small__inviteSvg} from '../Icon__small/Icon__small--invite.js';

export var invite = {
  name: 'invite',
  category: 'icon',
  colorable: true,
  svg: Icon__small__inviteSvg,
};
